module.exports = __webpack_public_path__ + "static/img/2.f169c4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/2.png
// module id = wQ5V
// module chunks = 44